import { UtilsService } from './../../services/utils.service';
import { Component, HostBinding } from '@angular/core';
import { IdiomaService } from '../../services/idioma.service';
import { MenuService } from '../../services/menu-service.service';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
})
export class DefaultLayoutComponent {

  @HostBinding('class.c-app') cAppClass = true;

  public perfectScrollbarConfig = {
    suppressScrollX: true,
  };

  constructor(
    public idiomaService: IdiomaService,
    private storageService: StorageService,
    private utilsService: UtilsService,
    private menuService: MenuService) {
  }

  get navItems() {
    const items = this.menuService.getMenu(this.idiomaService.selectedLanguage);
    items.forEach(val => {
      // Limpiar el estado anterior y reevaluar permisos
      if (val.attributes) {
        delete val.attributes.hidden;
      }

      // Evaluar si tiene alguno de los roles requeridos
      if (!this.storageService.hasRole(val.role)) {
        // Usuario no tiene el rol, ocultar elemento
        val.attributes = { ...val.attributes, hidden: true };
      }
    });
    return items;
  }

  get mostrarMenuLateral() {
    return this.storageService.isAuthenticated() && this.utilsService.getCurrentTiendaId() != null;
  }

  procesaPropagar() {
    // No es necesario hacer nada, el getter se recalcula automáticamente
  }
}
